import GoogleSignIn from './google-signin.builder';
import googleSignInConfig from './google-signin.builder.config';

export default {
  config: googleSignInConfig,
  component: GoogleSignIn,
};
